export default __webpack_public_path__ + "static/media/sdg-wheel_400.455f2281.png";